import styled from "styled-components";

export const HeaderSearchListsSection = styled.div`
  width: 100%;
  height: 540px;
  overflow-x: hidden;
  overflow-y: auto;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.theme === 'dark' ? '#3a3a3a' : '#d0d0d0'};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.theme === 'dark' ? '#4a4a4a' : '#b0b0b0'};
  }
`;

export const TabContainer = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) =>
    theme.theme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)'
  };

  /* Hide scrollbar */
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Tab = styled.button<{ active: boolean }>`
  padding: 6px 12px;
  border: none;
  background: transparent;
  color: ${({ active, theme }) =>
    active ? '#007aff' : theme.theme === 'dark' ? '#999' : '#666'
  };
  font-size: 13px;
  font-weight: ${({ active }) => (active ? 600 : 500)};
  cursor: pointer;
  white-space: nowrap;
  border-bottom: 2px solid ${({ active }) => (active ? '#007aff' : 'transparent')};
  margin-bottom: -13px;
  transition: all 0.2s ease;

  &:hover {
    color: #007aff;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const SectionTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.3px;
  color: ${({ theme }) => theme.COLORS.textw};
`;

export const ViewAllLink = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #007aff;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

export const LoadMoreButton = styled.button`
  width: 100%;
  padding: 10px;
  border: 1px solid ${({ theme }) =>
    theme.theme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)'
  };
  background: transparent;
  color: ${({ theme }) => theme.text};
  font-size: 13px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) =>
      theme.theme === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)'
    };
  }
`;

export const HeaderSearchListItemSection = styled.div``;

export const TradeDrawerListItemSection = styled.div`
  padding: 10px 12px;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${({ theme }) =>
      theme.theme === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)'
    };
  }
`;
